import { createContext, useContext, useState, type ReactNode } from 'react';

export type Lang = 'en' | 'zh';

interface LangContextType {
  lang: Lang;
  setLang: (l: Lang) => void;
  t: (en: string, zh: string) => string;
}

const LangContext = createContext<LangContextType>({
  lang: 'en',
  setLang: () => {},
  t: (en) => en,
});

export function LangProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<Lang>(() => {
    return (localStorage.getItem('ssd_lang') as Lang) || 'en';
  });

  const handleSetLang = (l: Lang) => {
    setLang(l);
    localStorage.setItem('ssd_lang', l);
  };

  const t = (en: string, zh: string) => (lang === 'zh' ? zh : en);

  return (
    <LangContext.Provider value={{ lang, setLang: handleSetLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
